import React from 'react';
import { useSelector } from 'react-redux';

import * as TRANSCRIPTION from '../../../../../../shared/constants/videoTranscript';
import EmptyTranscript from '../emptyTranscript';
import TranscriptList from '../index';
import {
  selectTranscriptionStatus,
  selectTranscriptPhrases,
} from '../../../../selectors/shareVideo';

const TranscriptWrapper = () => {
  const transcriptStatus = useSelector(selectTranscriptionStatus);
  const transcript = useSelector(selectTranscriptPhrases);

  return transcript ? (
    <TranscriptList transcript={transcript} />
  ) : (
    <EmptyTranscript
      failed={
        transcriptStatus === TRANSCRIPTION.FAILED ||
        transcriptStatus === TRANSCRIPTION.SHORT_DURATION ||
        !TRANSCRIPTION.TRANSCRIPTION_STATUSES.includes(transcriptStatus)
      }
      empty={transcriptStatus === TRANSCRIPTION.NO_AUDIO}
    />
  );
};

export default TranscriptWrapper;
